import react, { Component } from 'react';
import {HashRouter, Switch, Route, Link} from 'react-router-dom';
import Footer from './components/Footer/Footer';
import Party from './components/Party/Party';
import Category from './components/Category/Category';
import MainMenu from './components/MainMenu/MainMenu';
import './App.css';

class App extends Component {
  state = {
    categories : [
      {id : 0, name : ["ΚΑΦΕΔΕΣ & ΡΟΦΗΜΑΤΑ"], img : "./assets/images/coffee.jpg",  nav:[5, 1]},
      //{id : 1, name : ["ΡΟΦΗΜΑΤΑ"], img : "./assets/images/juice.jpg", takeAway : false, nav:[0, 2]},
      {id : 2, name : ["ΧΥΜΟΙ & ΑΝΑΨΥΚΤΙΚΑ"], img : "./assets/images/ouzo.jpg", nav:[1, 3]},
      {id : 3, name : ["ΦΑΓΗΤΟ"], img : "./assets/images/wine.jpg",nav:[2, 4]},
      {id : 6, name : ["ΓΛΥΚΑ"], img : "./assets/images/wine.jpg",nav:[2, 4]},
      {id : 4, name : ["ΑΛΚΟΟΛΟΥΧΑ"], img : "./assets/images/whiskey.jpg", nav:[3, 5]},
      {id : 7, name : ["COCKTAILS"], img : "./assets/images/whiskey.jpg", nav:[3, 5]},
      {id : 5, name : ["ΥΠΗΡΕΣΙΕΣ"], img : "./assets/images/cocktails.jpg",  nav:[4, 0]},
      // {id : 6, name : ["PARTY"], img : "./assets/images/cocktails.jpg",  nav:[4, 0], hidePrice : true}
    ],
    products : [
      {
        cat_id : 0,
        items : [
          { id : 1, name : ['Nescafe'], price : 3},
          { id : 2, name : ['Nescafe Φραπέ'], price : 3},
          { id : 3, name : ['Espresso'], price : 3},
          { id : 4, name : ['Espresso διπλό'], price : 3.5},
          { id : 5, name : ['Freddo Espresso'], price : 3.5},
          { id : 6, name : ['Cappuccino'], price : 3.5},
          { id : 7, name : ['Cappuccino διπλό'], price : 4},
          { id : 8, name : ['Freddo Cappuccino'], price : 4},
          { id : 9, name : ['Latte Cappuccino'], price : 4},
          { id : 10, name : ['Espresso Macchiato'], price : 3.5},
          { id : 11, name : ['Ισπανικός'], price : 4},
          { id : 12, name : ['Ισπανικός κρύος'], price : 4},
          { id : 13, name : ['Ελληνικός μονός'], price : 2.5},
          { id : 14, name : ['Ελληνικός διπλός'], price : 3},
          { id : 15, name : ['Φίλτρου'], price : 3},
          { id : 16, name : ['Τσάι'], price : 3},
          { id : 17, name : ['Ζεστή σοκολάτα'], price : 3.5},
          { id : 18, name : ['Κρύα σοκολάτα'], price : 3.5},
          { id : 19, name : ['Κακάο'], price : 3.5},
          { id : 20, name : ['Λευκή σοκολάτα με φουντούκι'], price : 4}
        ]    
      },
      {
        cat_id : 6,
        items : [
          { id : 1, name : ['Βάφλα'], price : 4.5},
          { id : 2, name : ['Βάφλα με Παγωτό'], price : 6},
          { id : 3, name : ['Παγωτό'], price : 2, description : ["Φράουλα, Βανίλια, Σοκολάτα, Τσιχλόφουσκα"]}
        ]    
      },
      {
        cat_id : 7,
        items : [
          { id : 1, name : ['Mai Tai'], price : 8},
          { id : 2, name : ['Mojito'], price : 8},
          { id : 3, name : ['Aperol Spritz'], price : 8},
          { id : 4, name : ['Bramble'], price : 8, 
            description : ["Bombay Gin, Λικέρ Μούρο, Χυμός Λεμόνι, Σιρόπι Ζάχαρης"]
          },
          { id : 5, name : ['Negroni'], price : 9}
        ]    
      },
      {
        cat_id : 2,
        items : [
          { id : 1, name : ['Χυμός'], price : 3.5},
          { id : 2, name : ['Φυσικός χυμός πορτοκάλι'], price : 4},
          { id : 3, name : ['Pepsi 250ml'], price : 3.5},
          { id : 4, name : ['Pepsi Max 250ml'], price : 3.5},
          { id : 5, name : ['Πορτοκαλάδα Ήβη 250ml'], price : 3.5},
          { id : 6, name : ['Λεμονάδα Ήβη 250ml'], price : 3.5},
          { id : 7, name : ['7 Up'], price : 3.5},
          { id : 8, name : ['Lipton Ice Tea'], price : 3.5,
            description : ["πράσινο, λεμόνι, ροδάκινο"]
          },
          { id : 8, name : ['Tuvunu σόδα'], price : 3.5},
          { id : 9, name : ['Pink Grapefruit Soda Oz'], price : 4},
          { id : 10, name : ['Νερό 0.5L'], price : 0.5},
          { id : 11, name : ['Red Bull'], price : 5}
        ]    
      },
      {
        cat_id : 3,
        items : [
          { id : 1, name : ['Τοστ με κασέρι'], price : 2},
          { id : 2, name : ['Τοστ με κασέρι και γαλοπούλα'], price : 2.5},
          { id : 3, name : ['Pizza κομμάτι'], price : 2.5},
          { id : 8, name : ['Hot Dog'], price : 2.5},
          { id : 7, name : ['Μερίδα πατάτες'], price : 3},
          { id : 5, name : ['Κοτομπουκιές με πατάτες'], price : 6},
          { id : 6, name : ['Club sandwich'], price : 6},
          { id : 4, name : ['Pizza'], price : 14},
          { id : 9, name : ['Pinsa Αλλαντικών'], price : 7, 
            description : ["Γαλοπούλα, gouda, σαλτσα napoliten, μπέικον"]
          },
          { id : 10, name : ['Pinsa Κοτόπουλο'], price : 7, 
            description : ["Τυρί κρέμα, κοτόπουλο, gouda, μέλι μουστάρδας"]
          },
          { id : 11, name : ['Burger'], price : 7, 
            description : ["μπιφτέκι, κέτσαπ, μουσταρδα, gouda"]
          },
          { id : 12, name : ['Cheeseburger'], price : 7, 
            description : ["Cheddar, μπέικον, μαγιονέζα, ντόματα, μαρούλι"]
          }
        ]    
      },
      {
        cat_id : 4,
        items : [
          { id : 1, name : ['Μπύρα Αλφα 330ml'], price : 4},
          { id : 2, name : ['Μπύρα Βεργίνα 330ml'], price : 4},
          { id : 3, name : ['Μπύρα Κάιζερ 330ml'], price : 4},
          { id : 4, name : ['Radler'], price : 4},
          { id : 5, name : ['Amstel Free'], price : 4},
          { id : 6, name : ['Μάμος 350ml'], price : 4},
          { id : 7, name : ['Μηλοκλέφτης'], price : 4},
          { id : 8, name : ['Ατομικό κρασί'], price : 5,
            description : ['λευκό, κόκκινο, ρόζε']
          },
          { id : 7, name : ['Gin Bombay'], price : 7},
          { id : 7, name : ['Bacardi'], price : 7},
          { id : 7, name : ['Campari'], price : 7},
          { id : 7, name : ['Whiskey Tullamore'], price : 7},
          { id : 7, name : ['Martini'], price : 7},
          { id : 7, name : ['Vodka 42 Below'], price : 7},

        ]    
      },
      {
        cat_id : 5,
        items : [
          { id : 1, name : ['Είσοδος'], price : 4},
          { id : 2, name : ['Είσοδος με χυμό'], price : 4.5, description : ["O δεύτερος χυμός 2.5"]},
          { id : 3, name : ['Είσοδος με τοστ'], price : 4.5},
          { id : 4, name : ['Είσοδος με φυσικό χυμό'], price : 5}
          // { id : 6, name : ['Είσοδος με χυμό & τοστ'], price : 5.5}
        ]    
      }
      // {
      //   cat_id : 6,
      //   no_price : true,
      //   items : [
      //     { id : 1, 
      //       name : ['Πάρτυ στον πολυχώρο μας. Περιλαμβάνει, φαγητό, ροφήματα και δραστηριότητες. Τιμή ανά άτομο 8 ευρώ.'], 
      //       price: 0}
      //   ]    
      // }
    ],
    party : {
        items : [
          // { id : 1, name : ['Basic Menu'], price : 7,
          //   description : ["Πιτσα, Λουκανοπιτακια, Tυροπιτακια, Ρολίνι ντομάτα ελιά, Donuts + Ροφήματα"]
          // },
          { id : 2, name : ['Standard Menu'], price : 8,
            description : ["Club Sandwich, Πατάτες,  Hot dog, Πίτσα + Ροφήματα"]
          }
          // { id : 3, name : ['Premium Menu'], price : 11,
          //   description : ["Club Sandwich, Πατάτες, Πιτσα, Burger και Κοτομπουκιές, Donuts + Ροφήματα"]
          // },
        ],
    },
    offers : ['Παιδικό πάρτι χωρίς μενού με χρέωση τιμοκατάλογο', 'Έκπτωση 10% σε όλα τα μενού'],
    offersFooter : ["Η έκπτωση δεν ισχύει τις περιόδους των γιορτών των Χριστουγέννων και του Πάσχα"],
    filter : []
  }

  componentDidMount() {
    
    let counter = 0;
    this.state.products.forEach(product => {
      product.items.forEach(item => counter++);
    });
    console.log("Total : "+counter);

    const logo = document.querySelector('.intro .intro-logo');
    const stripes = document.querySelectorAll(".intro .stripe");
    console.log(stripes);

    stripes.forEach((stripe, index) => {
      setTimeout(function(){
        stripe.classList.add("show");
      } , (100 * index))
    });
    
    setTimeout(function(){
      logo.classList.remove('hide');
      const enter = document.querySelector('.intro .enter');
      setTimeout(function(){
        enter.classList.remove('hide');
      }, 1400);
    }, 900);
   
}
  

  getProducts = (id) => {
    //console.log("get products" + index);
    let products = [];
    this.state.products.forEach((category, index) => {
      if(category.cat_id === parseInt(id)){
        let itemToPush = {...category, id : index};
        products.push(itemToPush);
      }
    });

    //console.log(products);
    return products;
  }

  getCategory = (id) => {
    return this.state.categories.findIndex(c => c.id === id);
  }

  setFilter = (filter) => {
    if(this.state.filter === filter){
      this.resetFilter();
    }else{
      this.setState({filter : filter});
    }
  }

  resetFilter = () => {
    this.setState({filter : ""});  
  }

  hideIntro = () => {
    const intro = document.querySelector('.intro');
    intro.classList.add('hide');  
  }
  render() {
    return (
      <HashRouter basename='/'>
        <div className="App">
        <div className="intro">
                  <div className="stripes">
                          <div className="stripe blue"></div>
                          <div className="stripe red"></div>
                          <div className="stripe purple"></div>
                          <div className="stripe green"></div>
                          <div className="stripe orange"></div>
                  </div>

                  <div className="intro-wrapper">

                      <div className="intro-logo hide">
                        <div className="intro-image">
                          <img src="./assets/images/logo.png" alt="kidcenter playground logo"/>
                        </div>
                      </div>

                      <div className="enter hide">
                        <Link to="/Menu">
                          <button onClick={this.hideIntro}>ΤΙΜΟΚΑΤΑΛΟΓΟΣ</button>
                        </Link>
                        <Link to="/Party">
                          <button onClick={this.hideIntro} class="partyBtn">PARTY</button>
                        </Link>
                      </div>
                  </div>
            </div>
          <header>
            <div className="logo">
              <img src="./assets/images/logo.png" alt="kidcenter playground logo"/>
            </div>
          </header>

          <div className="wrapper">
            
            <Switch>
                  <Route path="/Menu" 
                    render = { (props) => <MainMenu  {...props}
                                                  resetFilter = {this.resetFilter}
                                                  categories={this.state.categories}/>
                    }
                  />
                  <Route path="/Party" 
                    render = { (props) => <Party  {...props}
                                                  resetFilter = {this.resetFilter}
                                                  party={this.state.party}
                                                  offers={this.state.offers}
                                                  offersFooter={this.state.offersFooter}/>
                    }
                  />
                  <Route path="/category/:id" 
                    render={(props) => 
                      <Category {...props}
                        categories={this.state.categories}                  
                        getCategory={(index) => this.getCategory(index)}
                        getProducts={(index) => this.getProducts(index)}
                        filter = {this.state.filter}
                        setFilter = {(filter) => this.setFilter(filter)}
                        resetFilter = {this.resetFilter}/>}
                  />
            </Switch>

          </div>
          <footer>
              <Footer />
          </footer>
        </div>
      </HashRouter>
    );
  }
}

export default App;
